import { createContext, useContext, useEffect, useState } from "react";
import it from "./it";
import en from "./en";
import es from "./es";
import de from "./de";
import fr from "./fr";
import pt from "./pt";
import zh from "./zh";
import ar from "./ar";

export const LANGS = [
  { code: "it", label: "Italiano" },
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "pt", label: "Português" },
  { code: "de", label: "Deutsch" },
  { code: "fr", label: "Français" },
  { code: "zh", label: "中文" },
  { code: "ar", label: "العربية" },
];
const DICT = { it, en, es, de, fr, pt, zh, ar };

const initialLang = () => {
  const saved = typeof window !== "undefined" && localStorage.getItem("mf-lang");
  if (saved && DICT[saved]) return saved;
  const nav = (typeof navigator !== "undefined" && navigator.language?.slice(0, 2)) || "it";
  return DICT[nav] ? nav : "it";
};

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(initialLang);
  useEffect(() => {
    localStorage.setItem("mf-lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t: DICT[lang] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
